import type { ReactNode } from "react"
import { cn } from "~/lib/utils"

export function StepContent({
	children,
	spacing = "default"
}: {
	children: ReactNode
	spacing?: "default" | "compact" | "spacious"
}) {
	return (
		<div
			className={cn(
				"flex w-full flex-col items-center justify-center animate-in fade-in slide-in-from-bottom duration-500",
				spacing === "compact"
					? "gap-4"
					: spacing === "spacious"
						? "gap-12"
						: "gap-6"
			)}
		>
			{children}
		</div>
	)
}
